export default "__VITE_PUBLIC_ASSET__583c3e06__"